import { memo, useEffect } from "react";
import { useMap } from "react-leaflet";

const ReValidateMap = memo(({ zoomLevel }) => {
  const map = useMap();
  useEffect(() => {
    if (zoomLevel < 2) {
      map.invalidateSize();
    }
  }, [map, zoomLevel]);
  return null;
});

export default ReValidateMap;
